import i18n from "@/i18n";

export default {
  params: ["target"],
  validate(value, { target }) {
    return parseInt(value) <= parseInt(target);
  },
  message: i18n.t("integrations.error.smallerThanOtherOrEqual") + " '{target}'"
};
